import React from "react";
import ReactDOMServer from "react-dom/server";
import { AiFillCaretDown } from "react-icons/ai";
// import { getTitle } from "../../functions/getTitle";

export default class CustomPinnedRowRenderer {
  init(params) {
    this.selectAggrgate = function selectAggrgate() {
      if (!params.context.props.store.isLazyLoadEnabled) {
        try {
          var event = new MouseEvent("dblclick", {
            view: window,
            bubbles: true,
            cancelable: true,
          });
          document.getElementById(params.colDef.colId).dispatchEvent(event);
        } catch (e) {
          console.log(e);
        }
      }
    };

    if (
      params.value &&
      (params.colDef.cellRendererParams.columnTypeId == "5" ||
        params.colDef.cellRendererParams.columnTypeId == "17" ||
        params.colDef.cellRendererParams.columnTypeId == "22" ||
        ((params.colDef.cellRendererParams.columnTypeId == "19" ||
          params.colDef.cellRendererParams.columnTypeId == "7") &&
          (params.colDef.cellRendererParams.columnOptions.formula_column
            .column_type_id == "5" ||
            params.colDef.cellRendererParams.columnOptions.formula_column
              .column_type_id == "17")))
    ) {
      let values = params.value ? params.value?.split(" ") : [];
      let numberFormat;
      if (
        params.colDef.cellRendererParams.columnTypeId == "19" ||
        params.colDef.cellRendererParams.columnTypeId == "7"
      ) {
        numberFormat =
          typeof params.colDef?.cellRendererParams?.columnOptions?.formula_column?.options == "object"
            ? params.colDef?.cellRendererParams?.columnOptions?.formula_column?.options?.number_format
            : JSON.parse(
                params.colDef?.cellRendererParams?.columnOptions?.formula_column?.options
              )[0].number_format;
      } else {
        numberFormat =
          params.colDef.cellRendererParams.columnOptions.number_format;
      }
      if (params.colDef.cellRendererParams.columnTypeId == "22") {
        let val = values[1];
        if (!isNaN(val)) {
          let decimals = String(val).includes(".") ? String(val).split(".")[1].length : 2;
          values[1] = (val * 100).toFixed(decimals - 2);
        }
      }

      let formattedNumber = Util.formatNumber(
        Number(values[1]).toFixed(2),
        numberFormat,
        2
      );
      params.value = values[0] + " " + formattedNumber;
      
      if (params.colDef.cellRendererParams.columnTypeId == "22") {
        params.value += " %"
      }

    }

    this.htmlElement = document.createElement("div");
    this.htmlElement.id = params.colDef.colId;
    this.htmlElement.className = "d-flex align-items-center pinnedRowCell";
    this.htmlElement.style =
      "width:" +
      Number(params.colDef.width) +
      "px;height:" +
      params.node.rowHeight +
      "px;";
    // this.htmlElement.title=getTitle(params,params.cellMetaData)
    this.htmlElement.addEventListener("click", this.selectAggrgate);
    if (params.value && !params.context.props.store.isLazyLoadEnabled) {
      this.htmlElement.innerHTML = `<div class="downArrowPinnedCell">
                                      ${ReactDOMServer.renderToStaticMarkup(
                                        <AiFillCaretDown />
                                      )}
                                      </div>
                                      <div class="pinnedRowText">
                                      ${params.value}
                                      </div>`;
    } else {
      this.htmlElement.innerHTML = `<div/>`;
    }
  }

  getGui() {
    return this.htmlElement;
  }

  destroy() {
    this.htmlElement.removeEventListener("click", this.selectAggrgate);
  }
}
